
  import * as React from 'react'
import * as ReactDOM from 'react-dom'
  declare module "../helpers/types" {
    interface WindowSlice {
      React?: typeof React;
ReactDOM?: typeof ReactDOM;
    }
  }
  if (!('slice' in window)) {
    window.slice= {};
  }
  Object.assign(window.slice, { React });
Object.assign(window.slice, { ReactDOM });
